<template>
  <page-error :message="error.message"></page-error>
</template>

<script>
import PageError from '@/common/components/page/PageError'

export default {
  name: 'RestPageError',

  components: { PageError },

  props: {
    error: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestPageError.vue